import { useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { getTenantDataById } from "api/tenantApi";
import { TenantContext } from "context/AppProvider/TenantContext";
import { tryCatchWrapper } from "helpers/common";
import { useContext, useEffect } from "react";
import { setCompanyLogo } from "redux/actions/portal/settingsActionCreator";

export const useCurrentTenant = () => {
  const { user } = useAuth0();
  const { setTenantData, setTenantLogo, tenantData, tenantLogo } = useContext(TenantContext);
  const dispatch = useDispatch();

  const handleFetchCurrentTenant = async () => {
    if (!user) return;

    const tenantData = await getTenantDataById(user.stripeId);

    if (tenantData) {
      setTenantData(tenantData);
      setTenantLogo(tenantData.logo_url);
      dispatch(setCompanyLogo(tenantData.logo_url));
    }
  };

  useEffect(() => {
    if (!user || tenantData || tenantLogo) return;

    tryCatchWrapper(handleFetchCurrentTenant)();
  }, [user]);

  return {
    tenantData,
    tenantLogo,
    handleFetchCurrentTenant
  };
};
